// CSV-Monatsnachweis (ArbZG/§17-MiLoG-tauglich: Beginn/Ende/Dauer je Tag, deutsch) aus dem Server-Report.
// Nutzt die geteilten CSV-Helfer (DE-Semikolon, CRLF, BOM) + den v6-Formel-Injection-Guard: Zellen, die
// mit =, +, -, @ beginnen, bekommen ein führendes Apostroph — Excel interpretiert sie sonst als Formel.
import { formatWallClock, type AttendanceReportResponse } from '@wf/shared'
import { buildCsv, guardFormulaCell as guard } from '../export/csv'
import { formatDateDE, formatHMS } from '../time/format'

export function reportCsv(report: AttendanceReportResponse, pauseByDay: Record<string, number>): string {
  const headers = ['Mitarbeiter', 'Position', 'Tag', 'Beginn', 'Ende', 'Pause', 'Netto']
  const rows = report.days.map((d) => [
    guard(report.user.name),
    guard(report.user.position ?? ''),
    formatDateDE(d.day),
    d.startMs != null ? formatWallClock(d.startMs) : '',
    d.endMs != null ? formatWallClock(d.endMs) : '',
    pauseByDay[d.day] ? formatHMS(pauseByDay[d.day] ?? 0) : '',
    formatHMS(d.workedSeconds),
  ])
  return buildCsv(headers, rows)
}
